<div *ngIf="reportType == 'Briefly-Officer'">
  <div class="container" id="print-section" style="padding: 20px; background: white; border: 1px solid #ccc; border-radius: 8px; font-family: Arial, sans-serif; font-size: 14px;">
    <table class="table" style="border-collapse: collapse; width: 100%; text-align: left;">
      <thead>
        <tr style="background-color: #f0f0f0; font-weight: bold; text-align: center;">
          <th colspan="1" style="border: 1px solid #999; padding: 8px;">Vivek Saptahik</th>
          <th colspan="3" style="border: 1px solid #999; padding: 8px;">Issue Seller Payment Receipt Ledger</th>
          <th colspan="1" style="border: 1px solid #999; padding: 8px;">Briefly-Officer</th>
          <th colspan="2" style="border: 1px solid #999; padding: 8px;">Date</th>
        </tr>
        <tr style="background-color: #fafafa; text-align: center; font-weight: 600;">
          <th colspan="2" style="border: 1px solid #999; padding: 8px;">Datewise</th>
          <th colspan="3" style="border: 1px solid #999; padding: 8px;">
            From {{startDate | date:'dd-MM-yyyy'}} To {{endDate | date:'dd-MM-yyyy'}}
          </th>
          <th colspan="2" style="border: 1px solid #999; padding: 8px;">Page No</th>
        </tr>
        <tr style="background-color: #d6d8db; font-weight: bold;">
          <th style="border: 1px solid #999; padding: 8px;">Receipt No</th>
          <th style="border: 1px solid #999; padding: 8px;">Receipt Date</th>
          <th style="border: 1px solid #999; padding: 8px;">Entry Date</th>
          <th style="border: 1px solid #999; padding: 8px;">Issue Seller Name</th>
          <th style="border: 1px solid #999; padding: 8px;">Representative Name</th>
          <th style="border: 1px solid #999; padding: 8px;">Office Representative Name</th>
          <th style="border: 1px solid #999; padding: 8px; text-align: right;">Received Amount</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let data of advtOfficierbrieflyFormBeans; let i = index">
          <tr style="background-color: #e9ecef; font-weight: 600;">
            <td colspan="2" style="border: 1px solid #999; padding: 8px;">Office Representative</td>
            <td colspan="5" style="border: 1px solid #999; padding: 8px;">{{data.rep_name}}</td>
          </tr>

          <tr *ngFor="let data2 of data.rep_data; let j = index">
            <td style="border: 1px solid #999; padding: 6px;">{{data2.rcpt_no}}</td>
            <td style="border: 1px solid #999; padding: 6px;">{{data2.rcpt_date}}</td>
            <td style="border: 1px solid #999; padding: 6px;">{{data2.entry_date}}</td>
            <td style="border: 1px solid #999; padding: 6px;">{{data2.issue_seller_name}}</td>
            <td style="border: 1px solid #999; padding: 6px;">{{data2.rep_name}}</td>
            <td style="border: 1px solid #999; padding: 6px;">{{data2.off_rep_name}}</td>
            <td style="border: 1px solid #999; padding: 6px; text-align: right;">{{data2.rcv_amt | number:'1.2-2'}}</td>
          </tr>
        </ng-container>
      </tbody>
     
        <tr style="background-color: #e2e3e5; font-weight: 700;">
          <td colspan="6" style="border: 1px solid #999; padding: 10px; text-align: right;">Total:</td>
          <td style="border: 1px solid #999; padding: 10px; text-align: right;">{{advtOfficierbrieflyTotal | number:'1.2-2'}}</td>
        </tr>
      
    </table>
  </div>

  <div class="noPrint" style="margin-top: 20px; display: flex; justify-content: flex-end; gap: 10px;">
    <button
      (click)="exportExcel('Payment_Receipt_Reg_Brifly_Officer_Report')"
      mat-raised-button
      color="primary"
      style="padding: 10px 20px; font-weight: 600;"
    >
      Export
    </button>

    <button
      mat-raised-button
      color="primary"
      printSectionId="print-section"
      ngxPrint
      [useExistingCss]="true"
      style="padding: 10px 20px; font-weight: 600;"
    >
      Print
    </button>

    <button
      mat-button
      mat-dialog-close
      style="padding: 10px 20px; font-weight: 600;"
    >
      Close
    </button>
  </div>
</div>
